import { render, staticRenderFns } from "./CouponOrderDetail.vue?vue&type=template&id=efd2d4ec&scoped=true"
import script from "./CouponOrderDetail.vue?vue&type=script&lang=js"
export * from "./CouponOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./CouponOrderDetail.vue?vue&type=style&index=0&id=efd2d4ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd2d4ec",
  null
  
)

export default component.exports